"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.ReservationMessage = exports.HEADER_TIME = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const use_media_1 = require("use-media");
const cart_items_1 = require("../styles/cart-items");
const popover_1 = require("../styles/popover");
const hooks_1 = require("../utils/hooks");
exports.HEADER_TIME = '14:59';
const ReservationMessage = () => {
    const theme = (0, styled_components_1.useTheme)();
    const { i18n } = (0, hooks_1.useTranslate)();
    const isMobile = (0, use_media_1.useMedia)({ maxWidth: theme.breakpoint.tablet });
    const msg = isMobile ? `${i18n('cart_widget.reserved_for')} ${exports.HEADER_TIME}` : i18n('cart_widget.reserved');
    return (0, jsx_runtime_1.jsx)(cart_items_1.ReservationMsg, { children: msg });
};
exports.ReservationMessage = ReservationMessage;
const Header = () => ((0, jsx_runtime_1.jsxs)(popover_1.StyledHeader, { children: [(0, jsx_runtime_1.jsx)(popover_1.HeaderTitle, { children: (0, jsx_runtime_1.jsx)(exports.ReservationMessage, {}) }), (0, jsx_runtime_1.jsx)(popover_1.Placeholder, {})] }));
exports.Header = Header;
